import { useEffect } from "react";
import { useGetAccountQuery } from "@/shared/services";
import { handleMobileOnboarding } from "../utils";

export const useWizardFlow = () => {
  const { data: account } = useGetAccountQuery();
  useEffect(() => {
    if (!account) return;
    handleMobileOnboarding(account);
  }, [account]);
};
